<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div  class="kt-portlet kt-portlet--mobile">
      <div  class="kt-portlet__body">
          <div  >
              <div  class="kt-portlet__head pl-0 pr-0">
                  <div  class="kt-portlet__head-toolbar">
                      <div  class="kt-portlet__head-wrapper">
                          <div  class="dropdown dropdown-inline">
                              <button    data-target="#PromotionModal" class="btn btn-brand btn-icon-sm"><i   class="fas fa-plus"></i>Create
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
              <div  class="kt-form kt-form--label-right  kt-margin-b-10">
                  <div  class="row align-items-center">
                      <div  class="col-xl-12 order-2 order-xl-1">
                          <div  class="row align-items-center">

                          </div>
                          <div  class="row align-items-center">
                              <div  class="col-md-3 kt-margin-b-20-tablet-and-mobile">
                                  <div  class="kt-input-icon kt-input-icon&amp;#45;&amp;#45;left">
                                      <form >
                                          <input  type="text" placeholder="Search" class="form-control">
                                      </form>
                                  </div>
                              </div>
                              <div  class="col-md-3 kt-margin-b-20-tablet-and-mobile">
                                  <div  class="kt-form__group kt-form__group--inline">
                                      <div  class="kt-form__label">
                                          <label>Status:</label>
                                      </div>
                                      <div  class="kt-form__control">
                                          <select  class="form-control">
                                              <option  value="0">
                                                  Inactive
                                              </option>
                                              <option  value="1">
                                                  Active
                                              </option>
                                              <option  value="all">
                                                  All
                                              </option>
                                          </select>
                                      </div>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div  class="kt-section">
              <div  class="kt-section__content">
                  <div  class="table-responsive">
                      <table  class="table table-bordered table-hover table-striped">
                          <thead>
                              <tr>
                                  <th >ID</th>
                                  <th >Name</th>
                                  <th >Category</th>
                                  <th  style="width: 280px;">Bonus</th>
                                  <th >Min Deposit</th>
                                  <th >Rollover Type</th>
                                  <th >Rollover / Winover</th>
                                  <th >Limitation</th>
                                  <th  style="width: 100px;">User Levels</th>
                                  <th  class="text-center">Status</th>
                                  <th  class="text-center">Actions</th>
                              </tr>
                          </thead>
                          <tbody>

                              <tr  class="expandable-row">
                                  <td >47</td>
                                  <td >Live Casino 3%</td>
                                  <td >Casino</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;3.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">200.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">3x</td>
                                  <td >
                                      Daily (x3)
                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >46</td>
                                  <td >Sport Welcome Bonus 100%</td>
                                  <td >Sportsbook</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;100.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;1000.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">20x</td>
                                  <td >
                                      One Time

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >45</td>
                                  <td >Live Casino 3%</td>
                                  <td >Casino</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;3.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">200.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">3x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >44</td>
                                  <td >Welcome Bonus30%</td>
                                  <td >All Category</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;30.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;396.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">5x</td>
                                  <td >
                                      One Time

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >43</td>
                                  <td >BIrthDay Bonus</td>
                                  <td >All Category</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Amount
                                      <br > <strong>Bonus Amount:</strong>&nbsp;88.00
                                      <br > <strong>Bonus Limit:</strong>&nbsp;0.00
                                      <br >
                                  </td>
                                  <td  class="text-right">0.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">3x</td>
                                  <td >
                                      Yearly (x1)
                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >42</td>
                                  <td >Sport 5%</td>
                                  <td >Sportsbook</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;5.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">3x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >41</td>
                                  <td >Sport 10%</td>
                                  <td >Sportsbook</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;10.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">5x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >40</td>
                                  <td >Live Casino 3%</td>
                                  <td >Casino</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;3.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">3x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >38</td>
                                  <td >Live Casino 5%</td>
                                  <td >Casino</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;5.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">1000.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">5x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >36</td>
                                  <td >Slot 5% Bonus</td>
                                  <td >Slots</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;5.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">30.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">2x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >34</td>
                                  <td >Slot Bonus 10%</td>
                                  <td >Slots</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;10.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;888.00
                                      <br >
                                  </td>
                                  <td  class="text-right">30.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">3x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >33</td>
                                  <td >Sport Welcome Bonus 100%</td>
                                  <td >Sportsbook</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;100.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;2000.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">20x</td>
                                  <td >
                                      One Time

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >32</td>
                                  <td >Slot Welcome Bonus 100%</td>
                                  <td >Slots</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;100.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;296.00
                                      <br >
                                  </td>
                                  <td  class="text-right">30.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">5x</td>
                                  <td >
                                      One Time

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >31</td>
                                  <td >Welcome Bonus30%</td>
                                  <td >All Category</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;100.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;396.00
                                      <br >
                                  </td>
                                  <td  class="text-right">100.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">5x</td>
                                  <td >
                                      One Time

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                              <tr  class="expandable-row">
                                  <td >1</td>
                                  <td >No Bonus</td>
                                  <td >All Category</td>
                                  <td ><strong>Bonus Type:</strong>&nbsp;Bonus by Percentage
                                      <br > <strong>Bonus Multiplier:</strong>&nbsp;0.00%
                                      <br > <strong>Bonus Limit:</strong>&nbsp;0.00
                                      <br >
                                  </td>
                                  <td  class="text-right">30.00</td>
                                  <td >Rollover</td>
                                  <td  class="text-right">0x</td>
                                  <td >
                                      Unlimited

                                  </td>
                                  <td >
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Default
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP1
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> VIP2
                                      </div>
                                      <div ><span  class="kt-badge kt-badge--info kt-badge--dot kt-badge--lg"></span> Black List
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <div   id="statusToggle"><span  class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success"><label><input  type="checkbox" name="status" disabled="disabled"> <span ></span></label>
                                          </span>
                                      </div>
                                  </td>
                                  <td  class="text-center">
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionModal" disabled="disabled" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-edit"></i></button>
                                      <button  matTooltip="Add promotion detail"  data-target="#PromotionDetailModal" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"><i  class="fas fa-plus"></i></button>
                                  </td>
                              </tr>

                          </tbody>
                      </table>
                      <div  class="kt-pagination  kt-pagination--brand">
                          <ul class="kt-pagination__links">
                              <li class="kt-pagination__link--first"><a><i class="fa fa-angle-double-left kt-font-brand"></i></a></li>
                              <li class="kt-pagination__link--next"><a><i class="fa fa-angle-left kt-font-brand"></i></a></li>
                              <li class="kt-pagination__link--active"><a>1</a></li>
                              <li class="kt-pagination__link--prev"><a><i class="fa fa-angle-right kt-font-brand"></i></a></li>
                              <li class="kt-pagination__link--last"><a><i class="fa fa-angle-double-right kt-font-brand"></i></a></li>
                          </ul>
                          <div class="kt-pagination__toolbar">
                              <select class="form-control kt-font-brand" style="width: 60px;">
                                  <option value="10">10</option>
                                  <option value="20" selected="selected">20</option>
                                  <option value="30">30</option>
                                  <option value="50">50</option>
                              </select> <span class="pagination__desc">
          Showing 1 to 15 of 15 records
      </span></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div    tabindex="-1" role="dialog" aria-hidden="true" class="modal fade" id="PromotionModal">
          <div  role="document" class="modal-dialog modal-lg">
              <div  class="modal-content">
                  <div  class="modal-header">
                      <h5 class="modal-title">Create Promotion</h5>
                  </div>
                  <div  class="modal-body">
                      <div  >
                          <form   enctype="multipart/form-data" class="kt-form">
                              <div   class="form-group required">
                                  <label   class="control-label">Name:</label>
                                  <input   type="text" name="name"  class="form-control">
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Category</label>
                                  <select   name="category"  class="form-control">
                                      <option   value="0">
                                          All Category
                                      </option>
                                      <option   value="1">
                                          Casino only
                                      </option>
                                      <option   value="2">
                                          Slots only
                                      </option>
                                      <option   value="3">
                                          Sportsbook only
                                      </option>
                                  </select>
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Limitation:</label>
                                  <select   name="type"  class="form-control">
                                      <option   value="1">
                                          Unlimited
                                      </option>
                                      <option   value="2">
                                          First Time
                                      </option>
                                      <option   value="3">
                                          One Time
                                      </option>
                                      <option   value="4">
                                          Daily
                                      </option>
                                      <option   value="5">
                                          Weekly
                                      </option>
                                      <option   value="6">
                                          Yearly
                                      </option>
                                  </select>
                              </div>

                              <div   class="form-group required">
                                  <label   class="control-label">Bonus Type:</label>
                                  <select   class="form-control">
                                      <option   value="1">Amount</option>
                                      <option   value="2">Percentage</option>
                                  </select>
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Bonus:</label>
                                  <input   type="number" (wheel)="false" min="0.00" step="5" placeholder="0" class="form-control"> <span   class="form-text text-muted">Receive bonus by percentage (0%) Deposit: 50, Receive: 0</span></div>
                              <div   class="form-group required">
                                  <label   class="control-label">Bonus Limit:</label>
                                  <input   type="number" (wheel)="false" min="0.00" step="5" placeholder="0" class="form-control">
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Min Deposit:</label>
                                  <input   type="number" (wheel)="false" min="0.00" step="5" placeholder="0.00" class="form-control">
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Option:</label>
                                  <div   class="row">
                                      <div   class="col-2">
                                          <select   class="form-control">
                                              <option   value="1">Winover</option>
                                              <option   value="2">Rollover</option>
                                          </select>
                                      </div>
                                      <div   class="col-10">
                                          <input   type="number" (wheel)="false" min="0" placeholder="0x" class="form-control">
                                      </div>
                                  </div>
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Position:</label>
                                  <input   type="number" (wheel)="false" min="1" class="form-control">
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Display:</label>
                                  <select   class="form-control">
                                      <option   value="0">No</option>
                                      <option   value="1">Yes</option>
                                  </select>
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Status:</label>
                                  <select   class="form-control">
                                      <option   value="0">Inactive</option>
                                      <option   value="1">Active</option>
                                  </select>
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">New:</label>
                                  <select   class="form-control">
                                      <option   value="0">No</option>
                                      <option   value="1">Yes</option>
                                  </select>
                              </div>
                              <div   class="form-group">
                                  <label   class="control-label">Expiry Date:</label>
                                  <input   type="text" name="expiry" id="expiry" placeholder="Click to select" class="form-control datetime">
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">Keywords:</label>
                                  <input   name="keywords"  class="form-control">
                              </div>
                              <div   class="form-group required">
                                  <label   class="control-label">User Levels:</label>
                                  <div   class="col-lg-3 p-0">
                                      <div  tabindex="-1" class="multiselect" >
                                          <div class="multiselect__select"></div>
                                          <div class="multiselect__tags">
                                              <div class="multiselect__tags-wrap" style="display: none;"></div>

                                              <div class="multiselect__spinner" style="display: none;"></div>
                                              <input name="" type="text" autocomplete="nope" placeholder="Select option" tabindex="0" class="multiselect__input" style="width: 0px; position: absolute; padding: 0px;">
                                              <span class="multiselect__placeholder">
        Select option
      </span></div>
                                          <div tabindex="-1" class="multiselect__content-wrapper" style="max-height: 300px; display: none;">
                                              <ul class="multiselect__content" style="display: inline-block;">

                                                  <li class="multiselect__element"><span data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove" class="multiselect__option multiselect__option--highlight"><span>All</span></span>

                                                  </li>
                                                  <li class="multiselect__element"><span data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove" class="multiselect__option"><span>Default</span></span>

                                                  </li>
                                                  <li class="multiselect__element"><span data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove" class="multiselect__option"><span>VIP1</span></span>

                                                  </li>
                                                  <li class="multiselect__element"><span data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove" class="multiselect__option"><span>VIP2</span></span>

                                                  </li>
                                                  <li class="multiselect__element"><span data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove" class="multiselect__option"><span>Black List</span></span>

                                                  </li>
                                                  <li style="display: none;"><span class="multiselect__option">No elements found. Consider changing the search query.</span></li>
                                                  <li style="display: none;"><span class="multiselect__option">List is empty.</span></li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
                  <div  class="modal-footer">
                      <button   type="button" data-dismiss="modal" class="btn btn-secondary"> Close </button>
                      <button   type="button" data-dismiss="modal" class="btn btn-primary"> Submit </button>
                  </div>
              </div>
          </div>
      </div>
      <div    tabindex="-1" role="dialog" aria-hidden="true" class="modal fade" id="PromotionDetailModal">
          <div  role="document" class="modal-dialog modal-lg">
              <div  class="modal-content">
                  <div  class="modal-header">

                      <h5 class="modal-title">Edit Promotion Details</h5>

                  </div>
                  <div  class="modal-body"></div>
                  <div  class="modal-footer">
                      <button   type="button" data-dismiss="modal" class="btn btn-secondary">
                          Close
                      </button>
                      <button   type="button" data-dismiss="modal" class="btn btn-primary">
                        Submit
                      </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
